import styled from 'styled-components';
import { Colors } from 'assets/colors';
import { WL_CONFIG } from 'constants';

export const StyledWrapper = styled.div`
  padding-bottom: 100px;

  .flex-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .flex-row-end {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }

  .title-row {
    padding: 21px 51px;
    margin-bottom: 4px;
    display: block;

    .title {
      font-weight: bold;
      font-size: 24px;
      line-height: 30px;
      color: ${Colors.textPrimary1} !important;
      margin-left: 12px;
      margin-bottom: 0;
    }

    .back {
      color: #717679;
      width: 24px;
      height: 24px;
      margin-right: 3px;

      &-btn {
        padding: 0;
      }

      &-text {
        margin: 0;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #717679;
      }
    }
  }

  .status {
    font-weight: 600 !important;
    font-size: 12px !important;
    line-height: 16px !important;
    width: fit-content;
    padding: 4px 8px;
    border-radius: 4px;
    text-transform: capitalize;

    &--active {
      background: #e5dffc;
      color: #4b3a95 !important;
    }
    &--inactive {
      background: #e7e8e9;
      color: ${Colors.textPrimary1} !important;
    }
    &--new {
      background: #f9e6d2;
      color: #9c400b !important;
    }
    &--lost {
      background: #fae5e4;
      color: #aa2720 !important;
    }
  }

  .customer {

    &-name {
      font-weight: 800;
      font-size: 28px;
      line-height: 34px;
      color: ${Colors.textPrimary1};
      margin-right: 12px;
    }
  }

  .header-tabs {
      margin: 12px 0 20px;
      box-shadow: inset 0px -1px 0px #e7e8e9
  }

  .stat-tabs {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 0;
    border: 1px solid #d8dce2;
    border-radius: 5px;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    width: fit-content;
    @media (max-width: 767.98px) {
      flex-direction: column;
    }
    .tab {
      width: 264px;
      height: 74px;
      padding: 14px 18px;
      border-right: 1px solid #d8dce2;
      @media (max-width: 767.98px) {
        border-bottom: 1px solid #d8dce2;
        border-right: 0;
      }
      &:last-child {
        border: none;
      }
  
      &-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
  
        &-left {
          justify-content: flex-start;
          margin-bottom: 4px;
        }
      }
  
      &-desc {
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        color: ${Colors.textPrimary1};
      }
  
      &-right {
        font-weight: 600;
        font-size: 13px;
        line-height: 23px;
        color: #7d8284;
        max-width: calc(100% - 112px);
      }
    }
  }



  .details {
    &-title {
      font-weight: 700;
      font-size: 20px;
      line-height: 26px;
      color: ${Colors.textPrimary1};
      margin: 80px 0 20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #e8eaee;
      @media (max-width: 767.98px) {
        margin: 30px 0 0;
      }
    }

    &-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
      margin: 0 0 80px;
      @media (max-width: 767.98px) {
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr 1fr 1fr;
        margin: 20px 0 0;
      }
    }

    &-cell {
      display: flex;
      justify-content: flex-start;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: #717679;
      margin-bottom: 12px;

      &-left {
        width: 112px;
      }

      &-right {
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: ${Colors.textPrimary1};
      }

      &-colored {
        color: ${WL_CONFIG.colors.primary};
      }
    }
  }

  .strong {
    font-weight: 600;
  }

  .table-box {
    margin: 0 0;

    &-title {
      font-weight: 700;
      font-size: 20px;
      line-height: 26px;
      color: ${Colors.textPrimary1};
      margin: 78px 0 20px;
      padding-bottom: 0;
      border-bottom: 1px solid #e8eaee;
    }
  }

  .pagination {
    margin-top: -48px;
    @media (max-width: 575.98px) {
      margin-top: 0;
    }
  }

  /* New customer profile redesign */
  .profile-header {
    display: flex;
    gap: 24px;
    margin-bottom: 32px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e8eaee;
  }

  .profile-avatar {
    flex-shrink: 0;
  }

  .profile-info {
    flex: 1;
    min-width: 0;
  }

  .profile-info .customer-name {
    font-size: 28px;
    font-weight: 800;
    margin: 0 0 12px 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .vip-badge {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    background: linear-gradient(135deg, #f5e6ff 0%, #e5d4f7 100%);
    color: #672792;
    border: 1px solid rgba(103, 39, 146, 0.3);
  }

  .profile-actions {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
  }

  .profile-details-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px 24px;
    margin-bottom: 16px;
    font-size: 14px;
  }

  .profile-detail .label {
    color: #717679;
    margin-right: 6px;
  }

  .profile-detail .value {
    color: ${Colors.textPrimary1};
    font-weight: 500;
  }

  .customer-score {
    margin-top: 12px;
  }

  .customer-score-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 4px;
  }

  .customer-score .label {
    font-size: 14px;
    color: #717679;
  }

  .customer-score-info-icon {
    font-size: 14px;
    color: #717679;
    cursor: pointer;
  }

  .score-bar {
    max-width: 200px;
  }

  .dashboard-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 24px;
    @media (max-width: 991px) {
      grid-template-columns: 1fr;
    }
  }

  .revenue-card .ant-card-body {
    padding: 16px;
  }

  .revenue-metrics {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .metric {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 8px;
  }

  .metric-icon {
    font-size: 24px;
    color: ${WL_CONFIG.colors.primary};
    margin-top: 2px;
  }

  .metric-label {
    font-size: 12px;
    color: #717679;
    margin-bottom: 4px;
  }

  .metric-value {
    font-size: 18px;
    font-weight: 700;
    color: ${Colors.textPrimary1};
  }

  .revenue-trend-card .trend-indicator {
    margin-bottom: 16px;
  }

  .trend-up {
    color: #4BB43A;
    font-weight: 600;
    font-size: 14px;
  }

  .contact-bar {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    padding: 16px 24px;
    margin-bottom: 24px;
    background: ${WL_CONFIG.colors.primary};
    border-radius: 8px;
    color: white;
    font-size: 14px;
  }

  .contact-bar span {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .contact-bar .anticon {
    color: rgba(255, 255, 255, 0.9);
  }

  .revenue-trend-chart {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    height: 160px;
    margin-bottom: 16px;
    padding: 0 8px;
  }

  .trend-bar-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .trend-bar {
    width: 100%;
    min-height: 4px;
    max-height: 100%;
    background: ${WL_CONFIG.colors.primary};
    border-radius: 4px 4px 0 0;
    opacity: 0.85;
  }

  .trend-label {
    font-size: 12px;
    color: #717679;
  }

  .chart-container {
    height: 200px;
    margin-bottom: 16px;
  }

  .trend-summary {
    display: flex;
    gap: 24px;
    font-size: 14px;
  }

  .trend-summary .label {
    color: #717679;
    margin-right: 6px;
  }

  .donut-container {
    height: 180px;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .meal-donut {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    position: relative;
  }

  .meal-donut::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 70px;
    height: 70px;
    background: white;
    border-radius: 50%;
  }

  .meal-legend {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    font-size: 14px;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .legend-item .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #9B7DD4;
  }

  .legend-item:nth-child(1) .dot { background: #E5DFFC; }
  .legend-item:nth-child(2) .dot { background: #9B7DD4; }
  .legend-item:nth-child(3) .dot { background: #672792; }

  .metrics-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .metric-card {
    margin-bottom: 0;
  }

  .metric-card-content {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .metric-card-label {
    font-size: 14px;
    color: #717679;
  }

  .info-icon {
    font-size: 14px;
    color: #717679;
    cursor: help;
  }

  .metric-card-value {
    font-size: 18px;
    font-weight: 700;
    color: ${Colors.textPrimary1};
  }

  .last-orders-table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
  }

  .last-orders-table .table-header th {
    text-align: left;
    padding: 8px 16px 8px 0;
    font-weight: 600;
    color: #717679;
    border-bottom: 1px solid #e8eaee;
  }

  .last-orders-table .table-header .col-date { width: 140px; }
  .last-orders-table .table-header .col-amount { width: 100px; }
  .last-orders-table .table-header .col-status { width: auto; }

  .last-orders-table tbody tr:hover {
    background: #fafafa;
  }

  .last-orders-table tbody td {
    padding: 12px 16px 12px 0;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
  }

  .last-orders-table .table-row-link {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }

  .last-orders-table .table-row-link:hover {
    text-decoration: underline;
  }

  .last-orders-table .col-amount {
    white-space: nowrap;
  }

  .status-pill {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
    width: fit-content;
  }

  .status-pill.status--delivered,
  .status-pill.status--completed {
    background: #e6f7e6;
    color: #4BB43A;
  }

  .status-pill.status--cancelled {
    background: #ffe5e5;
    color: #aa2720;
  }

  .status-pill.status--new { background: #fff7e6; color: #d46b08; }
  .status-pill.status--in-progress { background: #e6f7e6; color: #389e0d; }
  .status-pill.status--ready { background: #e6f7e6; color: #389e0d; }
  .status-pill.status--on-the-way { background: #e6f4ff; color: #0958d9; }
  .status-pill.status--stranded { background: #ffe5e5; color: #aa2720; }
  .status-pill.status--needs-approval { background: #e6f4ff; color: #0958d9; }

  .loading-row,
  .empty-row {
    padding: 24px;
    text-align: center;
    color: #717679;
  }

  .last-orders-table a.status-pill {
    text-decoration: none;
  }

  .account-toggles-tiles {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 32px 0;
  }

  .account-toggles-tiles .toggle-tile {
    flex: 1;
    min-width: 200px;
    padding: 16px 20px;
    background: #f8f9fa;
    border: 1px solid #e8eaee;
    border-radius: 8px;
  }

  .account-toggles-tiles .toggle-tile .ant-space {
    width: 100%;
    justify-content: space-between;
  }

  .wallet-tile .wallet-tile-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .wallet-tile .wallet-tile-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #717679;
  }

  .wallet-tile .wallet-icon {
    font-size: 18px;
    color: ${WL_CONFIG.colors.primary};
  }

  .wallet-tile .wallet-label {
    font-weight: 500;
  }

  .wallet-tile .wallet-balance {
    font-size: 18px;
    font-weight: 700;
    color: ${Colors.textPrimary1};
  }

  .wallet-tile .adjust-balance-link {
    padding: 0;
    font-size: 13px;
  }
`;
